const API_BASE = process.env.REACT_APP_API_DOMAIN || '';
const VISITOR_KEY = 'pg_visitor_id';

export function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return crypto.randomUUID();
  }
}

function getPlatform() {
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'web';
}

export function trackHotspotEvent(hotspotId, eventType) {
  if (!API_BASE || !hotspotId) return;

  const body = {
    hotspotId,
    visitorId: getVisitorId(),
    eventType,
    platform: getPlatform(),
  };

  fetch(`${API_BASE}/guest/hotspot-event`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => {});
}
